import { render, staticRenderFns } from "./TriggerHistory.vue?vue&type=template&id=5552e67e&scoped=true&"
import script from "./TriggerHistory.vue?vue&type=script&lang=js&"
export * from "./TriggerHistory.vue?vue&type=script&lang=js&"
import style0 from "./TriggerHistory.vue?vue&type=style&index=0&id=5552e67e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5552e67e",
  null
  
)

export default component.exports